<template>
  <div class="file-upload-dropbox btn btn-outline-primary btn-block p-3 mb-3">
    <input
      type="file"
      class="input-file"
      multiple="isMultiple"
      :id="_uid"
      :accept="accept"
      :name="name"
      :disabled="disabled"
      @change="($e) => $emit('change', $e)"
    />
    <div>
      <i class="fas fa-cloud-upload fa-2x"></i>
    </div>
    <div>
      <div v-if="!isFailed || isSuccess">
        <p class="mb-0">Drag file(s) or click to browse</p>
      </div>
      <div v-if="isFailed">
        <p class="mb-0">Uploaded failed.</p>
      </div>
      <div v-if="loading">
        <p class="mb-0">
          Uploading {{ fileCount }} files...
          <i class="far fa-2x fa-spinner-third fa-spin text-primary"></i>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default{
  name: 'UploadDrop',
  props: {
    name: {
      type: String,
      required: true,
    },
    accept: {
      type: String,
      default: 'all'
    },
    isMultiple: {
      type: Boolean,
      default: true
    },
    fileCount: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isFailed: {
      type: Boolean,
      default: false,
    },
    isSuccess: {
      type: Boolean,
      default: false,
    },
  },
}
</script>